<!--
 * @Author: your name
 * @Date: 2020-12-27 22:22:47
 * @LastEditTime: 2020-12-28 14:24:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /yunlizhi/货主端1.0/src/pages/orderManage/orderManageDetail/BaseInfo.vue
-->
<template>
  <div class="BaseInfo-root">
    <!-- <order-status :order-detail="orderDetail" class="info-panel-first"></order-status> -->
    <order-summary
      :warehouse-type="warehouseType"
      :order-detail="orderDetail"
      :sensitive-fields="sensitiveFields"
    ></order-summary>
    <order-address
      v-if="carShow"
      :warehouse-type="warehouseType"
      :order-detail="orderDetail"
      class="info-panel"
      @change="changeDetail"
      @cancel="getOrderDetail"
    ></order-address>
    <supplier-information
      v-if="showSupplier"
      :detail="carrierInfoReq"
      class="info-panel"
    />
    <order-amount v-if="sensitiveFields.includes('order_amount')" :order-detail="orderDetail" class="info-panel"></order-amount>
  </div>
</template>

<script>
// import { EventBus } from '@/utils/event-bus'
import { featchOrderDetail } from '../api.js';
// import OrderStatus from './components/OrderStatus.vue'
import OrderSummary from './components/OrderSummary.vue';
import OrderAddress from './components/OrderAddress.vue';
import OrderAmount from './components/OrderAmount.vue';
import SupplierInformation from './components/SupplierInformation.vue';
import { SCENE } from '../warehouseList/constant';

const TypeList = {
  OUT: 1, // 出库
  IN: 2, // 入库
  DIAO: 3, // 调拨
};

export default {
  name: 'BaseInfo',
  components: {
    // OrderStatus,
    OrderSummary,
    OrderAddress,
    OrderAmount,
    SupplierInformation,
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => ({}),
    },
    sensitiveFields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      unifyOdrNo: this.$route.query.unifyOdrNo,
      // orderDetail: {},
      carShow: false,
      warehouseType: null,
    };
  },
  computed: {
    carrierInfoReq() {
      return this.orderDetail?.unifyWarehouseInfoList?.[0] || {};
    },
    showSupplier() {
      return this.orderDetail.scene === SCENE.STORE_ONLY;
    },
  },
  watch: {
    orderDetail(val) {
      this.filterScene(val.scene);
    },
  },
  created() {
    // this.getOrderDetail()
  },
  mounted() {},
  methods: {
    changeDetail() {
      this.carShow = false;
      this.$emit('change');
    },
    async getOrderDetail() {
      this.orderDetail = await featchOrderDetail({
        unifyOdrNo: this.unifyOdrNo,
      });
      this.filterScene(this.orderDetail.scene);
    },
    filterScene(data = '') {
      switch (data) {
        case SCENE.DELIVER_ONLY:
        case SCENE.DELIVER_TRANSPORT:
          this.warehouseType = TypeList.OUT;
          // this.onEvent('仓配出库')
          break;
        case SCENE.STORE_ONLY:
        case SCENE.STORE_TRANSPORT:
          this.warehouseType = TypeList.IN;
          // this.onEvent('仓配入库')
          break;
        case SCENE.DELIVER_STORE:
          this.warehouseType = TypeList.DIAO;
          // this.onEvent('仓内调拨')
          break;
        case SCENE.DELIVER_TRANSPORT_STORE:
          this.warehouseType = TypeList.DIAO;
          // this.onEvent('仓间调拨')
          break;
        default:
          break;
      }
      this.carShow = true;
    },
    // onEvent(data){
    //     EventBus.$emit('orderTypeShow', data)
    // }
  },
};
</script>

<style lang="less" scoped>
.info-panel {
  margin-top: 16px;
}
.info-panel-first {
  background-color: #fff;
}
</style>
